import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { config } from '@config'

import { LoginTitle, LoginContentContainer, LoginButton } from '../components'

const LoginSSO = () => {
  const { t } = useTranslation()

  return (
    <LoginContentContainer>
      <LoginTitle color="gray">{t('login.title')}</LoginTitle>
      <Link
        to={`${config.baseURL}/auth/login-exiros`}
        target="_parent"
        style={{ textDecoration: 'none', display: 'block' }}
      >
        <LoginButton type="primary" size="large">
          {t('login.iam_supplier')}
        </LoginButton>
      </Link>
      <Link
        to={`${config.baseURL}/auth/login-adsf`}
        target="_parent"
        style={{ textDecoration: 'none', display: 'block' }}
      >
        <LoginButton type="primary" size="large">
          {t('login.iam_employee')}
        </LoginButton>
      </Link>
    </LoginContentContainer>
  )
}

export { LoginSSO }
